import { render, staticRenderFns } from "./ColdStorageUse.vue?vue&type=template&id=9d6d38ca&scoped=true&"
import script from "./ColdStorageUse.vue?vue&type=script&lang=js&"
export * from "./ColdStorageUse.vue?vue&type=script&lang=js&"
import style0 from "./ColdStorageUse.vue?vue&type=style&index=0&id=9d6d38ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6d38ca",
  null
  
)

export default component.exports